/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const EventContextSlugs = core.serialization.object({
    space: core.serialization.string().optional(),
    workbook: core.serialization.string().optional(),
    sheet: core.serialization.string().optional(),
});
